import React, { useState } from 'react'
import { IonPage, IonIcon, IonHeader, IonTextarea, IonCard, IonAlert, IonToolbar, IonImg, IonBackButton, IonContent, IonText, IonItem, IonLabel, IonInput, IonButton } from '@ionic/react'
import { mailOutline } from "ionicons/icons"
import axios from 'axios'
import Loading from "../components/Loading";
import './Home.css';


function Contacto() {
  let [showAlert1, setShowAlert1] = useState(false);
  let [showAlert2, setShowAlert2] = useState(false);
  let [showAlert3, setShowAlert3] = useState(false);
  let [loading, setLoading] = useState(false)

  let [name, setName] = useState('')
  let [cel, setCel] = useState('')
  let [mail, setMail] = useState('')
  let [comments, setComments] = useState('')

  function manda() {
    if (name === '' || cel === '' || mail === '' || comments === '') {
      setShowAlert2(true)
    }
    else {
      setLoading(true)

      let datos = {
        "name": name,
        "email": mail,
        "cel": cel,
        "subject": "Comentario de Tebila App",
        "emailBody": comments
      }

      let data = {
        email: datos.email
      }

      axios.defaults.headers.post['Content-Type'] = 'application/json';
      axios.post('https://formsubmit.co/ajax/tebilaapp@gmail.com', {
        _subject: "Mensaje de Tebila App",
        Nombre: datos.name,
        Cel: datos.cel,
        Email: datos.email,
        Message: datos.emailBody
      })
        .then(response => {
          axios.post('https://app-tahara.herokuapp.com/api/v1/insertEmail', data)

          setName('')
          setMail('')
          setCel('')
          setComments('')

          setLoading(false)

          setShowAlert1(true)
        })
        .catch(error => {
          setShowAlert3(true)
        });
    }
  }

  return (
    <>
      <IonPage>
        <IonHeader>
          <IonToolbar color="tertiary">
            {/* <IonTitle>App Tahara</IonTitle> */}
          </IonToolbar>
        </IonHeader>

        <IonContent className="ion-padding ion-text-center">

          <IonAlert
            isOpen={showAlert1}
            onDidDismiss={() => setShowAlert1(false)}
            header={'Informacion enviada con exito!'}
            buttons={['OK']}
          />

          <IonAlert
            isOpen={showAlert2}
            onDidDismiss={() => setShowAlert2(false)}
            header={'Debes llenar todos los campos'}
            buttons={['OK']}
          />

          <IonAlert
            isOpen={showAlert3}
            onDidDismiss={() => setShowAlert3(false)}
            header={'Ocurrio un error, intenta de nuevo por favor'}
            buttons={['OK']}
          />

          <IonImg id="logo" src='https://i.ibb.co/7RXmfZr/logo.jpg' />

          <IonCard color='title'>
            <p id='screenTitles'>CONTACTO DE SOPORTE</p>
          </IonCard>

          <IonText className='fuente'>Si tienes alguna duda o comentarios, por favor contactanos llenando el siguiente formulario</IonText>

          <br /><br />
          <form>
            <input type="hidden" name="_captcha" value="false"></input>

            <IonItem>
              <IonLabel position="floating">Nombre</IonLabel>
              <IonInput value={name} type='text' name="Nombre" required='true' onIonChange={e => { setName(e.target.value) }}></IonInput>
            </IonItem>

            <IonItem>
              <IonLabel position="floating">Telefono</IonLabel>
              <IonInput value={cel} type='number' name="Celular" required='true' onIonChange={e => { setCel(e.target.value) }}></IonInput>
            </IonItem>

            <IonItem>
              <IonLabel position="floating">Email</IonLabel>
              <IonInput value={mail} type='text' name="Email" required='true' onIonChange={e => { setMail(e.target.value) }}></IonInput>
            </IonItem>

            <br /><br />

            <IonItem>
              <IonTextarea value={comments} placeholder="Comentarios" name='Mensaje' required='true' rows='5' onIonChange={e => { setComments(e.target.value) }}></IonTextarea>
            </IonItem>

            <br /><br />

            <IonButton color='background' onClick={manda}><IonIcon slot="start" icon={mailOutline} />Enviar</IonButton>
          </form>

          {loading ? <Loading /> : null}

          <br /><br />

          <IonText className='fuenteYo'>App desarrollada por David Amiga</IonText> <IonText><a href="mailto:davidamiga14@gmail.com">davidamiga14@gmail.com</a></IonText>
        </IonContent>

      </IonPage>
    </>
  )
}

export default Contacto